import React from "react";
import "./Footer.css";
import okImg from "../../assets/images/okImg.png";
import zoomImg from "../../assets/images/pngwing.com 1.png";
import { MdOutlineEmail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import colorImg from "../../assets/images/colour.png";

export const Footer = () => {
  return (
    // <div className="container">
    // <div className="footerContainer">
    //   <div>
    //     <div className="bi bi-envelope">&nbsp; Info.Occultking@gmail.com</div>
    //     <div className="bi bi-telephone">&nbsp; +91 9157591373</div>
    //   </div>
    //   <div style={{ display: "flex" }}>
    //     <div className="bi bi-geo-alt"></div>&nbsp;
    //     <div>
    //       Fortune Murali Park, Islampet, Vijayawada, Coastal Andhra, Andhra
    //       Pradesh, India
    //     </div>
    //   </div>
    //   <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
    //     <div className="okImg">
    //       <img src={okImg} />
    //     </div>
    //     &nbsp;
    //     <div>
    //       <div>Arihant Raaj</div>
    //       <div>Vastu Astro Numero Expert</div>
    //     </div>
    //   </div>
    // </div>
    // </div>
    <div className="container">
    <div className="footerContainerOnline">
      <div className="footerContact">
        <div><span><MdOutlineEmail /></span>&nbsp; Info.Occultking@gmail.com</div>
        <div><span><BsTelephone /></span>&nbsp; +91 9157591373</div>
      </div>
      <div className="footerZoomContainer">
      <div className="footerZoomImg">
         <img src={zoomImg}/>
       
      </div>
      {/* <div style={{ display: "flex", alignItems: "center",gap: "5px" }}> */}
      <div>
        <div className="okImg">
          <img src={colorImg } />
        </div>
       
        {/* <div className="footerName">
          <div>Arihant Raaj</div>
          <div>Vastu Astro Numero Expert</div>
        </div> */}
      </div>
        </div>
    </div>
    </div>
  );
};
